<template>
  <base-card :icons="icons" :heading="heading" :scrollable="true">
    <contact
      v-for="(contact, index) in contacts"
      :key="index"
      :contact="contact"
      :deletable="userRole === 'admin'"
      @remove-contact="removeContact(index)"
      @contact-click="navigate(contact)"
    />
  </base-card>
</template>
<script>
import BaseCard from "../UI/BaseCard.vue";
import Contact from "../UI/ListItems/Contact/Standard.vue";
export default {
  data() {
    return {};
  },
  computed: {
    userRole() {
      return this.$store.getters.userRole;
    },
  },
  methods: {
    removeContact(index) {
      this.$emit("remove-contact", index);
    },
    navigate(contact) {
      if (this.navigable) {
        this.$store.commit("setContact", contact);
        this.$router.push({
          name: "contact",
          params: {
            userId: contact.userId,
            role: contact.role.toLowerCase(),
          },
        });
      }
    },
  },
  created() {},
  components: {
    BaseCard,
    Contact,
  },
  props: ["contacts", "icons", "heading", "navigable"],
  emits: ["remove-contact"],
};
</script>
<style scoped></style>
